import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconFile } from "@tabler/icons-react";


export const catTiposExcelIcon = IconFile;
export const catTiposExcelHelpText = '* Aquí puede ver los tipos de excel.';

export class catTiposExcel extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposExcel";
        this.def.columns.c_category_id.defaultValue = "TiposExcel";
        this.Title = "Tipos de Excel";
        this.HelpText = catTiposExcelHelpText;
        this.Icon = catTiposExcelIcon;
    }
}